/**
 * @generated SignedSource<<9812e833ab9ac0c917ad1eb80d008893>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rankingLoaderQuery$variables = {
  club: string;
};
export type rankingLoaderQuery$data = {
  readonly club: {
    readonly leaderboardEnabled: string | null | undefined;
  };
};
export type rankingLoaderQuery = {
  response: rankingLoaderQuery$data;
  variables: rankingLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": "leaderboardEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "LEADERBOARD"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rankingLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rankingLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9afd4fb734fd4a2a858e575ba757462b",
    "id": null,
    "metadata": {},
    "name": "rankingLoaderQuery",
    "operationKind": "query",
    "text": "query rankingLoaderQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    leaderboardEnabled: configuration(key: \"LEADERBOARD\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4f1a6d2d2db2d40dfcc9fa61c8ab647";

export default node;
